export const NEW_EVENT_HANDLER_TEMPLATE = {
  name: "descriptive unique name",
  event: "event_type:event_location",
  condition: "boolean condition",
  actions: ["see examples below"],
};

export function configureMonaco(monaco) {
  // No-op
}
